module.exports = __webpack_public_path__ + "img/love-main.2275c78c.png";